import { PendingUser } from '@/lib/class/PendingUser'

export default {
  setCustomerId(state, value: string) {
    state.customerId = value
  },

  setCaregiversIds(state, value = []) {
    state.caregiversIds = value
  },

  setNumberOfCaregivers(state, value = 0) {
    state.numberOfCaregivers = value
  },

  setCaregiversCards(state, value = []) {
    state.caregiversCards = value
  },

  setCaregiversListByPostcode(state, value) {
    state.caregiversListByPostcode = value
  },

  setServiceRequestDraftId(state, value) {
    state.serviceRequestDraftId = value
  },

  setPendingUser(state, userProps) {
    const pendingUser = new PendingUser(userProps)
    state.registerUser = pendingUser
    sessionStorage.setItem('registerUser', pendingUser.toJsonStringify())
  },
  setCustomerLead(state, value = {}) {
    state.customerLead = value
  },
  setReactivateCC(state, value = {}) {
    state.reactivateCC = value
  },
  setNewCustomer(state, value = {}) {
    state.newCustomer = value
  },
  setCustomerInfo(state, value= {}) {
    state.customerInfo = value
   },
}
